const XMR = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      d="M10.002 0C4.47713 0 0 4.42485 0 9.88032C0 10.9706 0.177312 12.0211 0.507757 13H3.49788V4.68748L10.002 11.1099L16.5021 4.68748V13H19.4922C19.8227 12.0171 20 10.9706 20 9.88032C20.004 4.42485 15.5269 0 10.002 0Z"
      fill="#FF6600"
    />
    <path
      d="M8.42574 12.8093L5.43847 10V15.2434H1C2.85007 18.0966 6.18953 20 10 20C13.8105 20 17.1499 18.0966 19 15.2434H14.5615V10L11.5743 12.8093L10 14.2897L8.42574 12.8093Z"
      fill="#5E5E5E"
    />
  </svg>
);
export default XMR;
